import { ContactPerson } from "../models/generic";

export const ChayalPatel: ContactPerson = {
    address: "chayal.patel@asrs.org",
    name: "Chayal Patel",
};

export const StacyKiff: ContactPerson = {
    address: "stacy.kiff@asrs.org",
    name: "Stacy Kiff",
    phone: "(312) 477-8863",
    title: "ASRS Vice President of Education",
};



// WEBPACK FOOTER //
// ./src/constants/contacts.ts